
import Vue from 'vue';

export default Vue.extend({
  name: 'AnnoucementModalContent',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
  computed: {
    imageName(): string {
      return this.$device.isMobile ? `${this.image}-mobile` : this.image;
    },
    src(): string {
      return require(`./images/${this.imageName}.png`);
    },
    srcset(): string {
      return `${require(`./images/${this.imageName}.png`)}, ${require(`./images/${this.imageName}@2x.png`)} 2x, ${require(`./images/${this.imageName}@3x.png`)} 3x`;
    },
  },
});
